<div class="vds-alert__content-inner">
    @if (type() === "success") {
        <vds-icon name="checkmark-filled" class="vds-alert__icon--success" />
    } @else if (type() === "warning") {
        <vds-icon name="warning-filled" class="vds-alert__icon--warning" />
    } @else if (type() === "error") {
        <vds-icon name="error-filled" class="vds-alert__icon--error" />
    } @else {
        <vds-icon name="information-filled" class="vds-alert__icon--info" />
    }

    <div class="vds-alert__text">
        @if (title()) {
            <strong>{{ title() }}</strong>
        }
        @if (message()) {
            <p class="">{{ message() }}</p>
        }
    </div>
</div>

@if (hasAction()) {
    <button class="vds-alert__button" [attr.aria-label]="actionLabel()" (click)="action()">
        <vds-icon name="close-large" />
    </button>
}
